import React, {Component} from 'react';

import Window from '../components/Window';
import Error from '../components/Error';

class ErrorScreen extends Component {
  render() {
    return (
      <Window title="Error">
        <Error fullScreen/>
      </Window>
    );
  }
}

export default ErrorScreen;